import { tokens } from '@fluentui/react-components';

export function getCSATColor(score: number): string {
  if (score >= 4.0) return tokens.colorPaletteGreenForeground1;
  if (score >= 3.5) return tokens.colorPaletteMarigoldForeground2;
  return tokens.colorPaletteRedForeground1;
}
